import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Heart } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { useCart } from "@/context/CartContext";
import { api } from "@/lib/api";
import { ProductCard } from "@/components/store/ProductCard";

export default function Wishlist() {
  const { user, login } = useAuth();
  const { localWishlist } = useCart();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    document.title = "My Wishlist · Dealswagon";
    (async () => {
      setLoading(true);
      try {
        if (user) {
          const r = await api.get("/wishlist");
          setProducts(r.data);
        } else if (localWishlist.length) {
          // Load local wishlist by fetching individual products
          const all = await Promise.all(localWishlist.map((id) => api.get("/products", { params: { per_page: 100 } })));
          const items = all[0]?.data?.items || [];
          setProducts(items.filter((p) => localWishlist.includes(p.id)));
        } else {
          setProducts([]);
        }
      } catch { setProducts([]); }
      setLoading(false);
    })();
  }, [user, localWishlist]);

  return (
    <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10" data-testid="wishlist-page">
      <h1 className="font-heading text-3xl sm:text-4xl text-brand-navy mb-2">My Wishlist</h1>
      <p className="text-slate-600 mb-6">Save deals for later. Get notified when items drop.</p>

      {!user && (
        <div className="rounded-2xl bg-brand-yellowLight border border-brand-yellow p-4 mb-6 flex items-center justify-between gap-3">
          <div className="text-sm text-brand-navy">Sign in to save your wishlist across devices and unlock notifications.</div>
          <button onClick={login} data-testid="wishlist-signin-btn" className="bg-brand-navy text-white rounded-full px-4 h-10 text-sm font-bold">Sign in</button>
        </div>
      )}

      {loading ? (
        <div>Loading...</div>
      ) : products.length === 0 ? (
        <div className="text-center bg-white border border-slate-200 rounded-2xl py-20">
          <Heart className="h-12 w-12 mx-auto text-slate-300" />
          <div className="font-heading text-2xl text-brand-navy mt-4">Nothing saved yet</div>
          <Link to="/shop" className="mt-4 inline-flex bg-brand-navy text-white rounded-full px-5 h-10 items-center font-bold">Explore products</Link>
        </div>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
          {products.map((p) => <ProductCard key={p.id} product={p} testIdPrefix="wishlist" />)}
        </div>
      )}
    </main>
  );
}
